var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGovLetter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v18H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.35 1.944c1.82 0 3.3 1.494 3.3 3.33v7.451c.001 1.836-1.478 3.331-3.298 3.331H3.649c-1.82 0-3.299-1.494-3.299-3.33V5.274c0-1.837 1.48-3.331 3.3-3.331h10.7zm0 1.397H3.65a1.926 1.926 0 00-1.914 1.934v7.45c0 1.067.858 1.934 1.913 1.934h10.702a1.926 1.926 0 001.913-1.934v-7.45a1.926 1.926 0 00-1.913-1.934z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.157 4.804a.69.69 0 01.962.187.701.701 0 01-.184.968l-4.548 3.115a2.291 2.291 0 01-2.516.042L2.92 5.972a.698.698 0 01-.217-.962.692.692 0 01.956-.22L8.61 7.937a.906.906 0 00.999-.017l4.548-3.115z"
  })))));
}
export default SvgGovLetter;